module.exports = __webpack_public_path__ + "img/hourglass-bottom.33300182.svg";